import { useMemo } from 'react';
import styled from 'styled-components';
import { Show } from '@elfsight/lib-utils';
import { ChecklistControl } from '@elfsight/widget-filters';
import type { SalaryValue } from '../../../types';
import type { SalaryFilterOption } from '../types';
import { useAmountSalaries } from '../utils';
import { CurrencySelect } from './CurrencySelect';
import { PeriodSelect } from './PeriodSelect';

const uniqueCountMoreThanOne = (
  items: SalaryValue[],
  key: 'currency' | 'period'
) => new Set(items.map((item) => item[key])).size > 1;

type SalaryFilterProps = {
  filterName: string;
  options: SalaryFilterOption[];
};

export function SalaryFilter({ filterName, options }: SalaryFilterProps) {
  const amountSalaries = useAmountSalaries();

  const shouldShowCurrency = useMemo(
    () => uniqueCountMoreThanOne(amountSalaries, 'currency'),
    [amountSalaries]
  );

  const shouldShowPeriod = useMemo(
    () => uniqueCountMoreThanOne(amountSalaries, 'period'),
    [amountSalaries]
  );

  return (
    <Container>
      <Show when={shouldShowCurrency || shouldShowPeriod}>
        <Wrapper>
          <Show when={shouldShowCurrency}>
            <CurrencySelect />
          </Show>
          <Show when={shouldShowPeriod}>
            <PeriodSelect />
          </Show>
        </Wrapper>
      </Show>

      <ChecklistControl filterName={filterName} options={options} />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
`;
